//Animation reveal titres
const ratio = .1
const options = {
    root: null,
    rootMargin: '0px',
    threshold: ratio
}
const handleIntersect = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.intersectionRatio > ratio) {
            entry.target.classList.add('reveal-visible');
            observer.unobserve(entry.target);
        }
    })
}
window.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver(handleIntersect, options)
    const targets = document.querySelectorAll('.reveal');
    targets.forEach(function (target) {
        observer.observe(target);
    })
})


document.addEventListener("DOMContentLoaded", function () {
// Appel de la gestion de cookies RGPD
    let cookies = document.querySelector(".cookies");
    cookies.addEventListener("click", function (e) {
        e.preventDefault();
        if (tarteaucitron) {
            tarteaucitron.userInterface.openPanel();
        }
    });

    /*=============================================>>>>>
  = Topbut =
  ===============================================>>>>>*/
    let btn = document.querySelector("#topbut");
    if (btn != null) {
        window.addEventListener("scroll", function () {
            if (window.scrollY > 300) {
                btn.classList.add("visible");
            } else {
                btn.classList.remove("visible");
            }
        });
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector("html").scrollTop = 0;
            document.querySelector("body").scrollTop = 0;
        });
    }



    /*
    Option Sliders Partenaires
     */
    const sliderPartenaires = document.querySelector('#partenaires');
    if (sliderPartenaires) {
        const flktysliderPartenaires = new Flickity(sliderPartenaires, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": false,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }

    if ( matchMedia('screen and (min-width: 1200px)').matches ) {
            let elementsPartenaires = document.querySelectorAll('.partenaires-slider.no-slider');
        for (let i = 0; i < elementsPartenaires.length; i++) {
            let flktyPartenaires = Flickity.data(elementsPartenaires[i]);
            flktyPartenaires.destroy();
        }
    }

});